import { Box, CircularProgress } from '@mui/material';
import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';
import { lazy, Suspense } from 'react';

const SupportFeedback = lazy(() => import('pages/support-feedback'));

const Loader = (): JSX.Element => (
  <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
    <CircularProgress />
  </Box>
);

export const Route = createFileRoute('/_public/_empty/support_feedback')({
  component: SupportFeedbackWrapper,
});

function SupportFeedbackWrapper(): JSX.Element {
  return (
    <Suspense fallback={<Loader />}>
      <SupportFeedback />
    </Suspense>
  );
}
